import { render } from "./SearchWordsEdit.vue?vue&type=template&id=ef6ab7f2"
import script from "./SearchWordsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchWordsEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/search-words/components/SearchWordsEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef6ab7f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef6ab7f2', __exports__)) {
    api.reload('ef6ab7f2', __exports__)
  }
  
  module.hot.accept("./SearchWordsEdit.vue?vue&type=template&id=ef6ab7f2", () => {
    api.rerender('ef6ab7f2', render)
  })

}


export default __exports__